<template>
  <div class="card maturityR">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
          <div class="col cyan">
            <h3><i class="fas fa-file"></i>Cusip</h3>
          </div>
          <div class="text-right">
            <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> More Info</a>
          </div>
      </div>
    </div>
    <div class="card-body">
       <ul class="cusip mb-3">
            <span v-if="cusips.length == 0 ">There is no blocked cusip</span>
            <li v-for="cusip in cusips" :key="cusip.id">{{cusip}}</li>
        </ul>
        <footer>
            <div class="redb">
              <i class="fas fa-ban"></i>
              <span class="text-danger border border-danger rounded px-2">{{totalCusipsBlocked}}</span> Blocked Cusip
            </div>
            <div class="greenb">
              <i class="fas fa-clipboard-list"></i>
              <span class="text-success border border-success rounded px-2">{{totalCusipCount}}</span> Total Cusip
            </div>
        </footer>
    </div>
  </div> 
</template>
<script>
import config from "@/config";
import authService from "@/authService";
export default {
  name: "cusipWidget",
  data() {
    return {
     loading : false,
     totalCusipCount : 0,
      cusips:[],
      totalCusipsBlocked : 0,
    };
  },
  methods: {
     navigateListPage(){
      window.location.href = "/ims/ims-cusips";
    },
    getCusipCount(){
      this.loading = true;
      const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
      .get(
        config.baseUrlBidSide +
          "/cusip/counts?type=OFFER",
          auth
      )
      .then(result => {
        this.totalCusipCount = result.data.total;
        this.totalCusipsBlocked = result.data.blocked;
        this.cusips = result.data.blockedCusips;
        this.loading = false;
      })

    },
  },
  mounted() {
    this.getCusipCount();

  }
};
</script>